import React from "react";
import "./styles.css"
import Title from "../Title";
import { CopyToClipboardIcon } from "../../../Assets/images/svgs";

const ProfileInfoCard = ({ title, displayData, children }) => {
  const maskString = (password) => "*".repeat(password.length);

  return (
    <div className="profile-info-card">
      <Title>{title || "Details"}</Title>
      <div className="profile-details-container">
        {displayData.map((data, i) => (
          <div className="profile-detail-box" key={i}>
            <p className="detail-label">{data.label}</p>
            <p className="detail-value">{data.mask ? maskString(data.value) : data.value} {data.mask ? <CopyToClipboardIcon className="mask-string-copy-icon" onClick={() => {navigator.clipboard.writeText(data.value); if (data.onClick) data.onClick();}} /> : null}</p>
          </div>
        ))}
      </div>

      {children}
    </div>
  )
}

export default ProfileInfoCard
